import "./App.css";
import React, { Suspense, lazy } from "react";
import Header from "./components/header/header";
import Sidebar from "./components/sidebar/sidebar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "prismjs/themes/prism-twilight.css";
import { useSidebar } from "./components/sidebar/sidebar.context";
import Footer from "./components/footer/footer";
import LoadingSuspensePage from "./components/loading-suspense/loadingsuspense";
import AddTitle from "./components/tab-title/tabtitle";
import NotFoundPage from "./pages/not-found/notfound";

const Home = lazy(() => import("./pages/home/Home"));
const Component = lazy(() => import("./pages/component/ComponentPage"));
const ButtonPage = lazy(() => import("./pages/component/button/ButtonPage"));
const DatePickerPage = lazy(() =>
  import("./pages/component/datepicker/DatePickerPage")
);
const About = lazy(() => import("./pages/about/About"));
const Premise = lazy(() => import("./pages/premise/PremisePage"));
const InputPage = lazy(() => import("./pages/component/input/InputPage"));
const LoadingPage = lazy(() => import("./pages/component/loading/LoadingPage"));
const CardPage = lazy(() => import("./pages/component/card/CardPage"));
const AccordionPage = lazy(() =>
  import("./pages/component/accordion/AccordionPage")
);
const ModalPage = lazy(() => import("./pages/component/modal/ModalPage"));
const MultiSelectPage = lazy(() =>
  import("./pages/component/multiselect/MultiSelectPage")
);
const NotificationPage = lazy(() =>
  import("./pages/component/notification/NotificationPage")
);
const BreadcrumbPage = lazy(() =>
  import("./pages/component/breadcrumb/BreadcrumbPage")
);
const TooltipPage = lazy(() => import("./pages/component/tooltip/TooltipPage"));
const TypographyPage = lazy(() =>
  import("./pages/premise/typography/TypographyPage")
);
const OpacityPage = lazy(() => import("./pages/premise/opacity/OpacityPage"));
const ColorPage = lazy(() => import("./pages/premise/color/ColorPage"));

const ContentPage = lazy(() => import("./pages/content/ContentPage"));
const PrinciplesPage = lazy(() =>
  import("./pages/content/writingprinciples/WritingPrinciplesPage")
);
const FormatPage = lazy(() => import("./pages/content/format/FormatPage"));
const GrammarPage = lazy(() => import("./pages/content/grammar/GrammarPage"));

export const routes = [
  { path: "/", element: <Home />, title: "Home" },
  { path: "/about", element: <About />, title: "About Hatiuoron" },
  { path: "/content", element: <ContentPage />, title: "Content" },
  { path: "/content/grammar", element: <GrammarPage />, title: "Content - Grammar" },
  { path: "/content/format", element: <FormatPage />, title: "Content - Formatting" },
  { path: "/content/principles", element: <PrinciplesPage />, title: "Content - Principles" },
  { path: "/premise", element: <Premise />, title: "Premises" },
  { path: "/premise/color", element: <ColorPage />, title: "Premise - Coloring" },
  { path: "/premise/opacity", element: <OpacityPage />, title: "Premise - Opacity" },
  { path: "/premise/typography", element: <TypographyPage />, title: "Premise - Typography" },
  { path: "/component", element: <Component />, title: "Components" },
  { path: "/component/accordion", element: <AccordionPage />, title: "Component - Accordion" },
  { path: "/component/breadcrumb", element: <BreadcrumbPage />, title: "Component - Breadcrumb" },
  { path: "/component/button", element: <ButtonPage />, title: "Component - Button" },
  { path: "/component/card", element: <CardPage />, title: "Component - Card" },
  { path: "/component/datepicker", element: <DatePickerPage />, title: "Component - Date Picker" },
  { path: "/component/input", element: <InputPage />, title: "Component - Input" },
  { path: "/component/loading", element: <LoadingPage />, title: "Component - Loading" },
  { path: "/component/modal", element: <ModalPage />, title: "Component - Modal" },
  { path: "/component/multiselect", element: <MultiSelectPage />, title: "Component - Multi Select" },
  { path: "/component/notification", element: <NotificationPage />, title: "Component - Notification" },
  { path: "/component/tooltip", element: <TooltipPage />, title: "Component - Tooltip" },
  { path: "*", element: <NotFoundPage />, title: "Page Not Found" },
]

function App() {
  const { isSidebarOpen } = useSidebar();
  const { toggleSidebar } = useSidebar();

  return (
    <Router>
      <Header />
      <div className="flex bg-primary-50 bg-opacity-20">
        <Sidebar />
        {isSidebarOpen && (
          <div
            onClick={toggleSidebar}
            className="md:absolute md:left-0 md:right-0 md:bottom-0 md:top-0 bg-primary-500 bg-opacity-50 z-20"
          ></div>
        )}
        <div
          className={`w-full ${
            isSidebarOpen ? "md:overflow-hidden md:h-[calc(100vh-72px)]" : ""
          }`}
        >
          <Suspense fallback={<LoadingSuspensePage />}>
            <Routes>
              {routes.map((route, i) => (
                <Route
                  key={i}
                  path={route.path}
                  element={<AddTitle {...route} />}
                />
              ))}
            </Routes>
          </Suspense>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
